<script setup lang="ts">
import { useRoute } from 'vue-router/composables'
import ArrowLeft from '@/assets/icons/ArrowLeft.vue'
import MyTicketsInterface from '@/features/tickets/ui/MyTicketsInterface.vue'

const route = useRoute()
</script>

<template>
  <div class="my-tickets-page">
    <div class="content">
      <div class="page-header">
        <v-btn
          class="back-button"
          height="36"
          text
          :to="{ name: 'Event', params: { id: route.params.eventId } }"
        >
          <ArrowLeft />
          Back
        </v-btn>
        <h1 class="page-title">My Tickets</h1>
      </div>

      <MyTicketsInterface :event-id="Number(route.params.eventId)" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/style/mixins';

.my-tickets-page {
  padding: 80px 0 0;
  background: var(--color-grey-100);
  min-height: 100vh;

  p {
    margin: 0;
  }

  .content {
    max-width: 1190px;
    margin: 0 auto;
    padding: 40px;

    @media (max-width: 600px) {
      padding: 20px;
    }
  }
}

.page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;

  .back-button {
    text-transform: none;
    background-color: transparent;
    padding: 0 8px 0 0;
    min-width: 0;
    font-weight: 600;
    font-size: 20px;
    line-height: 36px;

    &::before {
      opacity: 0;
    }

    &:hover::before,
    &:focus-visible::before {
      opacity: 0.18;
    }
  }

  .page-title {
    @include font-h2;

    text-transform: uppercase;

    @media (max-width: 600px) {
      @include font-h3;
    }
  }
}
</style>
